<script setup>
defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
  backgroundColor: {
    type: String,
    default: () => '',
  },
});
</script>
<template>
  <ul v-if="data?.items" class="m-0 p-0 brands-services__items">
    <li
      v-for="(item, index) in data.items"
      :key="item.title"
      :class="[
        'm-0',
        backgroundColor === 'black' ? 'white' : 'black',
        backgroundColor
          ? `brands-services__item brands-services__item--${backgroundColor}`
          : 'brands-services__item',
      ]"
      data-aos="fade-up"
      :data-aos-delay="index >= 1 ? 100 + 100 * index : 100"
    >
      <p
        v-if="item.title"
        class="mb-0 brands-services__item-title h6-mobile"
        v-html="item.title"
      ></p>
      <div
        v-if="item.description"
        class="mb-0 brands-services__item-text body-2-regular"
        v-html="item.description"
      ></div>
    </li>
  </ul>
</template>

<style scoped lang="scss">
@use 'sass:math';
.brands-services {
  &__items {
    background-color: transparent;
    display: grid;
    grid-template-columns: 1fr;
    gap: 8px;
    list-style: none;
    @include media-breakpoint-up(sm) {
      grid-template-columns: repeat(2, 1fr);
    }
    @include media-breakpoint-up(md) {
      grid-template-columns: repeat(4, 1fr);
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 8);
    }
  }
  &__item {
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px 16px 20px;
    &--white {
      background-color: $gray;
    }
    &--black {
      background-color: rgba($surface-container-opacity, 0.5);
    }
    &--gray {
      background-color: $white;
    }
    @include media-breakpoint-up(sm) {
      gap: 16px;
      padding: 24px 24px 28px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(padding-top, 24);
      @include responsive-spacing(padding-left, 24);
      @include responsive-spacing(padding-right, 24);
      @include responsive-spacing(padding-bottom, 28);
      @include responsive-spacing(border-radius, 8);
      @include responsive-spacing(gap, 16);
    }
  }
}
</style>
